import { Constant } from "../webjam/constant";
import { getParseLanguage } from "./constant-Utils";
class languageDynamicLoader {
    language = "en";
    languageTranslation = {};

    setLanguage(language) {
        this.language = getParseLanguage[language];
        this.setLanguageTranslation()
    }

    setLanguageTranslation() {
        if (this.language) {
            if (this.languageTranslation[this.language] == undefined) {
                fetch(Constant.App.chatTranslate + "/assets/language-" + this.language + ".json")
                    .then(e => e.json())
                    .then(e => {
                        this.languageTranslation[this.language] = e;
                    })
                    .catch(e => {
                        console.log("language error ", e)
                    })
            }
        }
    }

    getLanguageTranslation() {

        return this.languageTranslation[this.language] || ""
    }
}
export default new languageDynamicLoader()